import { Component, OnInit } from '@angular/core';
import { ResultControlInfoService } from '../result/result-control-info'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonControlService } from 'projects/data-portal/src/app/core/services/common-control.service';
import { CustomSortingService } from 'projects/data-portal/src/app/core/sort/custom-sorting.service';
import { SortableColumn } from 'projects/data-portal/src/app/core/sort/sortable-column';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseComponent } from 'projects/data-portal/src/app/core/components/base/base.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ViewerService } from '../../../../services/viewer-service';
import { AppConfigService } from '../../../../core/config/app-config.service';
import { ViewerSearch } from 'projects/data-portal/src/app/models/viewer-search';
import { PlottingDetails } from '../../../../models/plotting-map-details'

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent extends BaseComponent implements OnInit {

  pageNumber: number = 1;
  itemsCount: number;
  pageSize: number = 200;
  mapPlottingCount=0;
  totalListedCount=0;
  gridPageStart: number = 1;
  gridPageEnd: number = 200;


  result: FormGroup;
  columns: string[];
  appealsData: any[];
  errorFromServer: boolean = false;
  formItems: any[];
  resultFormGroup = [];
  public searchCriteria: string = "";
  public plotingMapData: PlottingDetails[] = [];
  public plotingAllMapData: PlottingDetails[] = [];
  public plotingSpecificMapData: PlottingDetails[] = [];
  basemapType = 'streets';
  mapZoomLevel = 13;
  mapCenter: any;

  isViewMap: boolean = false;
  isHideMap: boolean = true;
  isMapVisible: boolean = false;



   sortableColumns: Array<SortableColumn> = [
    new SortableColumn('null', 'Select', null,'7%'),
    new SortableColumn('rtn', 'RTN', null,'110px'),
    new SortableColumn('townName', 'CITY/TOWN', null,'150px'),
    //new SortableColumn('buildingNo,streetName', 'RELEASE ADDRESS', null, '17%'),
    new SortableColumn('streetName,buildingNo', 'RELEASE ADDRESS', null, '17%'),
    //new SortableColumn('address', 'RELEASE ADDRESS', null, '17%'),
    new SortableColumn('zipCode', 'ZIP CODE', null,'8%'),
    new SortableColumn('siteName', 'SITE NAME LOCATION AID', null,'22%'),
    new SortableColumn('category', 'REPORTING CATEGORY', null, '10%'),
    new SortableColumn('notificationDate', 'NOTIFICATION DATE', null, '15%'),
    new SortableColumn('complianceStatus', 'REGULATORY STATUS', null, '15%'),
    new SortableColumn('date', 'REGULATORY DATE', null, '10%'),
    new SortableColumn('phase', 'PHASE', null, '10%'),
    new SortableColumn('raoClass', 'RAO CLASS', null, '10%'),
    new SortableColumn('chemicalType', 'CHEMICAL TYPE', null, '10%'),
    new SortableColumn('null', 'FILE', null, '10%'),
  ];



  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private service: ResultControlInfoService,
    private commonControlService: CommonControlService,
    private customSortingService: CustomSortingService,
    private modalService: BsModalService,
    private viewerService: ViewerService
  ) {
    super(modalService)
  }

  ngOnInit(): void {
    this.formItems = this.service.getResultProperties();
    this.result = this.commonControlService.toFormGroup(this.formItems);
    this.createForm(this.pageNumber, this.pageSize);

  }

  pageCountChanged(event): void {

    this.pageNumber = 1;
    this.pageSize = event.target.value;
    this.createForm(this.pageNumber, this.pageSize);
    this.gridFooter(this.pageNumber, this.pageSize);
  }
  pageChanged(event: PageChangedEvent): void {

    this.pageNumber = event.page;
    this.createForm(this.pageNumber, this.pageSize);
    this.gridFooter(this.pageNumber, this.pageSize);
  }

  private createForm(pageNumber: number, pageSize: number): void {

    this.resultSearch();
  }

  public sort(sortableColumn: SortableColumn): void {
    debugger;
    sortableColumn.toggleDirection();
    this.customSortingService.clearPreviousSorting(sortableColumn, this.sortableColumns);
    this.resultSearch();
  }

  resultSearch() {
debugger;
    this.hideMap();
    this.plotingAllMapData.splice(0, this.plotingAllMapData.length);
    this.searchCriteria = ""
    this.SpinnerService.show();
    this.pageNumber = this.pageNumber || 1;
    var viewerSearch = new ViewerSearch();
    let arrayQueryString = [];
    this.route.queryParamMap.subscribe((params: any) => {
      arrayQueryString = params.params.queryString.split('_');
      arrayQueryString.forEach((item) => {
        if (item.length > 0) {
          viewerSearch[item.split(':')[0]] = item.split(':')[1];
          this.searchCriteria += item.split(':')[0].replace(/([a-z])([A-Z])/, '$1 $2').replace(/(?:^|\s)\S/g, (res) => { return res.toUpperCase(); }) + ": " + item.split(':')[1] + ", ";
        }
      });
    })
    this.searchCriteria = this.searchCriteria.substring(0, this.searchCriteria.length - 2);

    let sortableColumn = this.customSortingService.getSortableColumn(this.sortableColumns);
    this.mapPlottingCount=0;
    this.viewerService.getAllViewer(viewerSearch, this.pageNumber, this.pageSize, sortableColumn).subscribe((data: any) => {

      if (data.length != 0) {
        this.resultFormGroup = data;
        this.itemsCount = data[0].totalCount;
        this.totalListedCount=this.resultFormGroup.length;
        this.resultFormGroup.forEach(item => {
          if (item.longitude != undefined && item.latitude != undefined) {
            this.plotingAllMapData.push({
              siteName: item.siteName,
              rtn: item.rtn,
              address: item.address,
              town: item.townName,
              status: item.complianceStatus,
              notes: "Map location approximated by Address Match",
              lat: Number(item.latitude),
              lon: Number(item.longitude),
              siteStatus: item.siteType
            });
            this.mapCenter = [Number(item.longitude), Number(item.latitude)];
            this.mapPlottingCount=this.mapPlottingCount+1;
          }

        })
        this.plotingMapData = this.plotingAllMapData;

      }
      this.gridFooter(this.pageNumber, this.pageSize);
      this.SpinnerService.hide();
    }, (err) => {
      this.SpinnerService.hide();
      alert("Internal Server Error - Something went Wrong");
    });


  }

  back() {
    window.history.back();
  }

  onChangeHandler(rtn: string, siteName: string, address: string, townName: string, complianceStatus: string, latitude: string, longitude: string, openClosed: string, limitation: string) {

    this.isMapVisible = false;
    this.isHideMap = true;
    this.isViewMap = false;
    if (this.plotingSpecificMapData.find(x => x.rtn === rtn)) {
      this.plotingSpecificMapData.splice(this.plotingSpecificMapData.findIndex(x => x.rtn === rtn), 1);
    }
    else {
      if (longitude != undefined && latitude != undefined) {
        this.plotingSpecificMapData.push({
          siteName: siteName,
          rtn: rtn,
          address: address,
          town: townName,
          status: complianceStatus,
          notes: "Map location approximated by Address Match",
          lat: Number(latitude),
          lon: Number(longitude),
          siteStatus: (limitation == 'Y' ? "ClosedLimitation" : openClosed)
        });
        this.mapCenter = [Number(longitude), Number(latitude)];
      }
    }
    if (this.plotingSpecificMapData.length == 0) {
      this.plotingMapData = this.plotingAllMapData;
    }
    else {
      this.plotingMapData = this.plotingSpecificMapData;
    }
  }

  viewMap() {
    if (this.plotingMapData.length == 0) {
      alert("No Longitude and Latitude for this record");
    }
    else {
      this.SpinnerService.show();
      this.isMapVisible = true;
      this.isHideMap = false;
      this.isViewMap = true;
    }

  }

  hideMap() {
    this.isMapVisible = false;
    this.isHideMap = true;
    this.isViewMap = false;
  }

  exportExcel() {
    this.SpinnerService.show();
    var viewerSearch = new ViewerSearch();
    let arrayQueryString = [];
    this.route.queryParamMap.subscribe((params: any) => {
      arrayQueryString = params.params.queryString.split('_');
      arrayQueryString.forEach((item) => {
        if (item.length > 0) {
          viewerSearch[item.split(':')[0]] = item.split(':')[1];
          this.searchCriteria += item.split(':')[0].replace(/([a-z])([A-Z])/, '$1 $2').replace(/(?:^|\s)\S/g, (res) => { return res.toUpperCase(); }) + ": " + item.split(':')[1] + ", ";
        }
      });
    })
    this.viewerService.getExportExcelViewer(viewerSearch).subscribe((data: any) => {
      var binaryData = atob(data.data);

      const blob = new Blob([new Uint8Array(binaryData.length).map((_, index) => binaryData.charCodeAt(index))], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a link element to trigger the download
      const a = document.createElement('a');
      a.href = url;
      a.download = 'SearchableSite.xlsx'; // Set the desired file name
      a.click();

      // Revoke the object URL to free up resources
      window.URL.revokeObjectURL(url);
      this.SpinnerService.hide();
    }, (err) => {
      this.SpinnerService.hide();
      alert("Internal Server Error - Something went Wrong");
    });
  }


  mapLoadedEvent(status: boolean) {
    debugger;
    console.log('The map has loaded: ' + status);
    this.SpinnerService.hide();
  }


  gridFooter(pageNumber: number, pageSize: number) {
    if (pageNumber != 1) {
      this.gridPageStart = (pageSize * (pageNumber - 1)) + 1
    }
    else {
      this.gridPageStart = 1;
    }

    if (this.itemsCount >= (pageNumber * pageSize)) {
      this.gridPageEnd = (pageNumber * pageSize);
    }
    else {
      this.gridPageEnd = this.itemsCount;
    }
  }

}
